import {useDraggableCollection as $h8ULG$useDraggableCollection, useDraggableItem as $h8ULG$useDraggableItem, DragPreview as $h8ULG$DragPreview} from "react-aria/useDraggableCollection";
import {useDraggableCollectionState as $h8ULG$useDraggableCollectionState} from "react-stately/useDraggableCollectionState";
import {useDroppableItem as $h8ULG$useDroppableItem, useDroppableCollection as $h8ULG$useDroppableCollection, useDropIndicator as $h8ULG$useDropIndicator} from "react-aria/useDroppableCollection";
import {useDroppableCollectionState as $h8ULG$useDroppableCollectionState} from "react-stately/useDroppableCollectionState";
import {isVirtualDragging as $h8ULG$isVirtualDragging} from "react-aria/private/dnd/DragManager";
import {useMemo as $h8ULG$useMemo} from "react";

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 





function $b2e02c624cc31fc7$export$2cfc5be7a55829f6(options) {
    let dragAndDropHooks = (0, $h8ULG$useMemo)(()=>{
        let { onDrop: onDrop, onInsert: onInsert, onItemDrop: onItemDrop, onReorder: onReorder, onRootDrop: onRootDrop, getItems: getItems, renderPreview: renderPreview } = options;
        let isDraggable = !!getItems;
        let isDroppable = !!(onDrop || onInsert || onItemDrop || onReorder || onRootDrop);
        let hooks = {};
        if (isDraggable) {
            hooks.useDraggableCollectionState = function useDraggableCollectionStateOverride(props) {
                return (0, $h8ULG$useDraggableCollectionState)({
                    ...props,
                    ...options,
                    getItems: options.getItems
                });
            };
            hooks.useDraggableCollection = (0, $h8ULG$useDraggableCollection);
            hooks.useDraggableItem = (0, $h8ULG$useDraggableItem);
            hooks.DragPreview = (0, $h8ULG$DragPreview);
            hooks.renderPreview = renderPreview;
        }
        if (isDroppable) {
            hooks.useDroppableCollectionState = function useDroppableCollectionStateOverride(props) {
                return (0, $h8ULG$useDroppableCollectionState)({
                    ...props,
                    ...options
                });
            };
            hooks.useDroppableItem = (0, $h8ULG$useDroppableItem);
            hooks.useDroppableCollection = function useDroppableCollectionOverride(props, state, ref) {
                return (0, $h8ULG$useDroppableCollection)({
                    ...props,
                    ...options
                }, state, ref);
            };
            hooks.useDropIndicator = (0, $h8ULG$useDropIndicator);
        }
        if (isDraggable || isDroppable) hooks.isVirtualDragging = (0, $h8ULG$isVirtualDragging);
        return hooks;
    }, [
        options
    ]);
    return {
        dragAndDropHooks: dragAndDropHooks
    };
}


export {$b2e02c624cc31fc7$export$2cfc5be7a55829f6 as useDragAndDrop};
//# sourceMappingURL=useDragAndDrop.mjs.map
